// extracted by mini-css-extract-plugin
export default {"header":"_3Gwft","wrapper":"_3jDNm","headerWrapper":"_3pQp3","headerLink":"_21nzU","channelsWrapper":"_2f-M2","channelSectionTitle":"_3Njbv","channelSectionSubtitle":"TRJ-m"};